import { Navigate } from 'react-router'
import { useAuth } from '@/auth/AuthProvider'
import { useDoc } from '@/data/hooks'
import { EmptyState } from '@/ui'

/** Route by role: staff → console; clients → their portal (or a picker when they belong to several). */
export function Home() {
  const { user, role } = useAuth()
  const { data, loading } = useDoc<{ clientIds?: string[] }>(user ? `users/${user.uid}` : null)
  if (role === 'staff') return <Navigate to="/staff" replace />
  if (loading) return null
  const ids = data?.clientIds ?? []
  if (ids.length === 1) return <Navigate to={`/c/${ids[0]}`} replace />
  if (ids.length > 1) return <Navigate to="/clients" replace />
  return (
    <main id="main" className="grid min-h-dvh place-items-center px-6">
      <EmptyState eyebrow="No portal yet" title="Your invitation hasn’t been linked to a portal." className="max-w-md">
        Open the link from your invitation email, or ask your Sonder contact to resend it.
      </EmptyState>
    </main>
  )
}
